module.exports = __webpack_public_path__ + "img/the-knot-24.e13632cd.png";